module.exports = __webpack_public_path__ + "fonts/NoirPro-Light.25188312.woff2";